import { Bone } from '@/components/ui/Skeleton'

/**
 * Placeholder row for the shift-template carousel: same card width, top colour
 * rule, company badge, title and time line as ShiftTemplateCard.
 */
export function ShiftTemplateBones({ count = 4 }: { count?: number }): React.ReactElement {
  return (
    <div role="status" aria-busy="true" aria-label="Loading shift templates" className="kc-loader-in flex gap-3 overflow-hidden">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="relative h-[118px] w-56 shrink-0 overflow-hidden rounded-lg border border-gray-200 bg-white p-3 pt-3.5 shadow-[0_1px_3px_rgba(15,23,42,0.05)] dark:border-gray-700 dark:bg-gray-800 sm:w-60"
        >
          <Bone tint className="absolute inset-x-0 top-0 h-0.5 rounded-none" />
          <div className="flex items-start gap-3">
            <Bone tint className="mt-4 h-7 w-7 shrink-0 rounded-full" />
            <div className="min-w-0 flex-1 space-y-2 pt-0.5">
              <Bone tint className="h-2.5 w-1/2" />
              <Bone className={i % 2 ? 'h-3.5 w-3/5' : 'h-3.5 w-4/5'} />
              <Bone className="h-2.5 w-2/3" />
            </div>
          </div>
        </div>
      ))}
      <span className="sr-only">Loading shift templates</span>
    </div>
  )
}
